import { functions } from "../Config";

export const savePreference = async (orden) => {
  //functions.useEmulator("localhost", 5001);
  const fPreference = functions.httpsCallable("createPreference");
  let res = await fPreference(orden);
  return res.data;
};
